import { validateEnumTranslations } from '../../safety_checks';

//⚠️IMPACT attention changer aussi l'enum GoogleReviewStatus dans le fichier prisma
export enum GoogleReviewStatus {
  NEW = 'NEW',
  SUGGESTED = 'SUGGESTED',
  REPLIED = 'REPLIED',
  IGNORED = 'IGNORED',
}

export const GOOGLE_REVIEW_STATUS_TRANSLATE_KEY = 'GOOGLE_REVIEW_STATUS_';

export const GoogleReviewStatusTranslation = {
  'fr-FR': {
    [`${GOOGLE_REVIEW_STATUS_TRANSLATE_KEY}${GoogleReviewStatus.NEW}`]: 'Sans réponse',
    [`${GOOGLE_REVIEW_STATUS_TRANSLATE_KEY}${GoogleReviewStatus.SUGGESTED}`]: 'Suggestion prête',
    [`${GOOGLE_REVIEW_STATUS_TRANSLATE_KEY}${GoogleReviewStatus.REPLIED}`]: 'Répondu',
    [`${GOOGLE_REVIEW_STATUS_TRANSLATE_KEY}${GoogleReviewStatus.IGNORED}`]: 'Ignoré',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(GoogleReviewStatus, GoogleReviewStatusTranslation, GOOGLE_REVIEW_STATUS_TRANSLATE_KEY, true);
